import { render, staticRenderFns } from "./OrderProofView.vue?vue&type=template&id=305fe1a0"
import script from "./OrderProofView.vue?vue&type=script&lang=js"
export * from "./OrderProofView.vue?vue&type=script&lang=js"
import style0 from "./OrderProofView.vue?vue&type=style&index=0&id=305fe1a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports